<template>
  <v-navigation-drawer
    fixed
    width="350"
    right
    permanent
    transition="scale-transition"
    class="side-bar-filters"
  >
    <v-layout row>
      <v-flex lg12>
        <v-layout row>
          <v-flex d-flex align-center class="text-xs-left py-0">
            <div class="flex-grow-0">
              <v-icon @click="closeFilters()">close</v-icon>
            </div>
            <h3>{{ translation('filters.btn-filter') }}</h3>
          </v-flex>
          <v-flex class="text-xs-right py-0 px-0">
            <v-btn color="default" depressed @click.stop="clearFilters()">
              {{ translation('filters.btn-clear.filters') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-divider class="mt-2"></v-divider>
        <!-- filters group wrapper -->
        <v-layout row wrap>
          <!-- save filters section -->
          <v-flex xs12 d-flex class="py-0">
            <v-expansion-panel class="elevation-0" :value="opened">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h3 class="panel--header">{{ translation('filter.group.name.save-filter') }}</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 d-flex>
                        <filter-save
                          v-if="renderFilters"
                          :current-filter="selectedFiltersGen"
                          @set-filters="setFilters">
                        </filter-save>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <!-- time period filters group -->
          <v-flex xs-12 d-flex class="py-0">
            <!-- filter date time component -->
            <v-expansion-panel class="elevation-0" :value="opened">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h3 class="panel--header">{{ translation('filter.group.name.time-period') }}</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 d-flex>
                        <filter-date-time
                          filter-key = "PrivacyGdpr_filterDateTime"
                          @update-filter-date-time="updateFilters">
                        </filter-date-time>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <!-- filters group -->
          <v-flex xs12 d-flex class="py-0">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h3 class="panel--header">{{ translation('filter.group.name.handler') }}</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "dealer_name"
                          filter-key = "filterDealer"
                          filter-name = "filter.name.dealer"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <!-- filters group -->
          <v-flex xs12 d-flex class="py-0">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h3 class="panel--header">{{ translation('filter.group.name.consent') }}</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "consent"
                          filter-key = "filterConsent"
                          filter-name = "filter.name.consent"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "channel"
                          filter-key = "filterChannel"
                          filter-name = "filter.name.channel"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "consent_source"
                          filter-key = "filterConsentSource"
                          filter-name = "filter.name.consentSource"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "user_name"
                          filter-key = "filterConsentEmployee"
                          filter-name = "filter.name.consentEmployee"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <!-- filters group -->
          <v-flex xs12 d-flex class="py-0">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h3 class="panel--header">{{ translation('filter.group.name.contact') }}</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "contact_type"
                          filter-key = "filterContactType"
                          filter-name = "filter.name.contact-type"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "customer_type"
                          filter-key = "filterCustomerType"
                          filter-name = "filter.name.customer-type"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <!-- filters group -->
          <v-flex xs12 d-flex class="py-0">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h3 class="panel--header">{{ translation('filter.group.name.lead') }}</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "car_model"
                          filter-key = "filterCarModel"
                          filter-name = "filter.name.car-model"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "lead_source"
                          filter-key = "filterLeadSource"
                          filter-name = "filter.name.lead-source"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "lead_channel"
                          filter-key = "filterLeadChannel"
                          filter-name = "filter.name.lead-channel"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "lead_event"
                          filter-key = "filterLeadEvent"
                          filter-name = "filter.name.lead-event"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                      <v-flex x12 d-flex>
                        <filter-select
                          v-if="renderFilters"
                          filter-id = "action_name"
                          filter-key = "filterLeadAction"
                          filter-name = "filter.name.lead-action"
                          @update-filters="updateFilters">
                        </filter-select>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>

          <v-layout row>
            <v-flex class="py-3">
              <v-btn color="accent" depressed @click.stop="applyFilters()">
                {{ translation('filters.btn-apply.filters') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import _ from 'underscore'
import { parseDate } from '@/util/util'
// import filter components
import FilterSelect from '@/components/filters/FilterSelectNew'
import FilterDateTime from '@/components/filters/FilterDateTimeNewGen'
import FilterSave from '../../filters/FilterSave.vue'

let initFilters = [
  {
    outputId: 'dealer_name',
    queryKey: 'filterDealer',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  },
  {
    outputId: 'consent',
    queryKey: null,
    disabled: false,
    type: 'select',
    returnObject: true,
    data: [
      { name: 'filter.select.defined-all', value: -1 },
      { name: 'filter.select.defined-yes', value: 1 },
      { name: 'filter.select.defined-no', value: 0 }
    ],
    default: { name: 'filter.select.defined-all', value: -1 }
  },
  {
    outputId: 'channel',
    queryKey: 'filterChannel',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  },
  {
    outputId: 'consent_source',
    queryKey: 'filterConsentSource',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  },
  {
    outputId: 'user_name',
    queryKey: 'filterConsentEmployee',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  },
  {
    outputId: 'contact_type',
    queryKey: 'filterContactType',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  },
  {
    outputId: 'customer_type',
    queryKey: 'filterCustomerType',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  },
  {
    outputId: 'car_model',
    queryKey: 'filterCarModel',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  },
  {
    outputId: 'lead_source',
    queryKey: 'filterLeadSource',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  },
  {
    outputId: 'lead_channel',
    queryKey: 'filterLeadChannel',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  },
  {
    outputId: 'lead_event',
    queryKey: 'filterLeadEvent',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  },
  {
    outputId: 'action_name',
    queryKey: 'filterLeadAction',
    multiple: true,
    disabled: true,
    type: 'select',
    default: [],
    pagination: {
      sortBy: 'name',
      rowsPerPage: 100
    }
  }
]

const timePeriods = [
  { name: 'filter.time-periods.any',
    value: []
  },
  { name: 'filter.time-periods.last-7-days',
    value: [
      moment().startOf('day').subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    ]
  },
  { name: 'filter.time-periods.current-month',
    value: [
      moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
    ]
  },
  { name: 'filter.time-periods.last-month',
    value: [
      moment().startOf('month').subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
      moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
    ],
    default: true
  },
  { name: 'filter.time-periods.last-6-months',
    value: [
      moment().startOf('day').subtract(6, 'month').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    ]
  },
  { name: 'filter.time-periods.this-year',
    value: [
      moment().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('year').format('YYYY-MM-DD HH:mm:ss')
    ]
  },
  { name: 'filter.time-periods.last-year',
    value: [
      moment().startOf('year').subtract(1, 'year').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('year').subtract(1, 'year').format('YYYY-MM-DD HH:mm:ss')
    ]
  }
]

let timePeriodsExtend = []

export default {
  name: 'DashboardSidebarFilters',
  components: {
    FilterSelect,
    FilterDateTime,
    FilterSave
  },
  props: {
    dashboardId: { type: String, required: true }
  },
  data () {
    return {
      renderFilters: false,
      extendFilters: false,
      opened: 0
    }
  },
  computed: {
    ...mapGetters(['selectedFiltersGen', 'translation', 'filterItemGen'])
  },
  created () {
    // set dashboard data with received props
    this.setGeneric(true)
    // assign timePeriodsExtend from config
    if (process.env.VUE_APP_EXTEND_TIME_PERIODS) {
      try {
        timePeriodsExtend = JSON.parse(process.env.VUE_APP_EXTEND_TIME_PERIODS)
      } catch (e) {}
    }
    !timePeriodsExtend ? this.setTimePeriods(this.timePeriodsTranslated(timePeriods)) : this.setTimePeriods(this.handleTimePeriods())
    this.$log.info(`-${this.dashboardId} dashboard filters component created-`)
    this.$log.info('Initializing filters', initFilters)

    // extend initFilters
    if (process.env.VUE_APP_EXTEND_INIT_FILTERS) {
      try {
        initFilters = [...initFilters, ...JSON.parse(process.env.VUE_APP_EXTEND_INIT_FILTERS)]
        this.extendFilters = true
      } catch (e) {}
    }
    initFilters.forEach(filter => {
      if (!filter.queryKey) {
        filter.data.forEach(data => {
          data.name = this.translation(data.name)
        })
      }
      return filter
    })
    this.setInitialSelectedFilters(initFilters)
    this.resetFilters()
    // fetch filters data
    // TODO - set auto updateFilters if timePeriod not set
    // this.updateFilters() // enable if no default timePeriod set
    this.renderFilters = true
  },
  methods: {
    ...mapMutations({
      setInitialSelectedFilters: 'GEN_SET_INITIAL_SELECTED_FILTERS',
      // disabled filters mutations
      setItemStatus: 'GEN_SET_ITEM_FILTER_STATUS',
      // set dashboard as generic
      setGeneric: 'GEN_SET_GENERIC',
      // set time periods
      setTimePeriods: 'GEN_SET_TIMEPERIODS'
    }),
    ...mapActions([
      // fetch filters actions
      'fetchDataGen',
      'fetchAnyTimeGen',
      'setActiveFilter'
    ]),
    updateFilters (preference) {
      if (!preference) {
        this.setActiveFilter({ name: '', value: null })
      }
      const requestPayloadData = {
        filters: preference || this.selectedFiltersGen,
        dashboardId: this.dashboardId
      }
      // fetch filters
      initFilters.forEach(val => {
        if (val.queryKey) {
          if (val.type === 'time') {
            this.fetchAnyTimeGen({ selected: requestPayloadData, filterId: val.outputId, filterKey: val.queryKey })
          } else {
            this.fetchDataGen({ selected: requestPayloadData, filterId: val.outputId, filterKey: val.queryKey, pagination: val.pagination })
          }
        }
      })
    },
    applyFilters () {
      this.$emit('apply-filters')
    },
    resetFilters () {
      this.$store.commit('GEN_RESET_FILTERS', initFilters)
    },
    clearFilters () {
      // reset filters to init state
      this.resetFilters()
      // reset active saved filter
      this.setActiveFilter({ name: '', value: null })
      // set disabled states to false
      initFilters.forEach(val => {
        this.setItemStatus(val.outputId, true)
      })
      this.updateFilters()
      // emit event for fetching data with selected filters
      this.$emit('clear-filters')
    },
    closeFilters () {
      this.$emit('close-filters')
    },
    handleTimePeriods () {
      // override default value
      let overrideDefaultPeriod = false

      timePeriodsExtend.filter(period => {
        if (period.default) {
          overrideDefaultPeriod = true
        }
      })
      if (overrideDefaultPeriod) {
        timePeriods.forEach(period => _.omit(period, 'default'))
      }
      // extend time periods with config
      return [...this.timePeriodsTranslated(timePeriodsExtend), ...this.timePeriodsTranslated(timePeriods)]
    },
    timePeriodsTranslated (periods) {
      let translatedTimePeriods = periods.map(timePeriod => {
        timePeriod.name = this.translation(timePeriod.name)
        return timePeriod
      })
      return translatedTimePeriods
    },
    setFilters (preference) {
      initFilters.forEach(val => {
        if (val.outputId && preference.hasOwnProperty(val.outputId)) {
          this.$store.commit('GEN_SET_SELECTED_FILTER_ITEM', { key: val.outputId, value: preference[val.outputId] })
        }
        let dateTime = []
        if (preference.hasOwnProperty('date_time') && preference['date_time'].length) {
          this.$store.commit('GEN_SET_DATE_FROM_PICKER', parseDate(preference['date_time'][0], 'YYYY-MM-DD'))
          this.$store.commit('GEN_SET_DATE_TO_PICKER', parseDate(preference['date_time'][1], 'YYYY-MM-DD'))
          dateTime.push(preference['date_time'][0])
          dateTime.push(preference['date_time'][1])
          this.$store.commit('GEN_SET_SELECTED_FILTER_DATE_TIME', dateTime)
        } else {
          this.$store.commit('GEN_SET_DATE_FROM_PICKER', '')
          this.$store.commit('GEN_SET_DATE_TO_PICKER', '')
          this.$store.commit('GEN_SET_SELECTED_FILTER_DATE_TIME', dateTime)
        }
      })
      this.updateFilters(preference)
    }
  },
  destroyed () {
    this.extendFilters = false
    this.$log.info(`-${this.dashboardId} filters before destroyed-`)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.side-bar-filters {
  padding: 25px 15px;
  .v-btn {
    border-radius: 4px;
    text-transform: none;
    min-width: 100px;
  }
  .v-expansion-panel {
    .v-expansion-panel__container {
      border-bottom: 1px solid rgba(0, 0, 0, .2);
      &:hover {
        border-bottom: 1px solid rgba(0, 0 , 0 , .3);
      }
      &.v-expansion-panel__container--active {
        border-bottom: 1px solid #009aff;
        .v-expansion-panel__header {
          color: #009aff;
          &:hover {
            background-color: transparent;
          }
        }
      }
      .v-expansion-panel__header {
        padding: 10px 0 !important;
        &:hover {
          background-color: rgba(0, 0 , 0 , .04);
        }
      }
    }
  }
  .v-card {
    box-shadow: none;
    .v-card__text {
      padding: 16px 0;
    }
  }
}
</style>
